// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3391":"349c3991f0e22ea3","4651":"d80bcfaf5ebc8f79","5217":"8404e99389becbf8","8857":"1cb7fe081a968309"}[chunkId] + ".js";
};